import { Tab } from 'bootstrap';

/**
 * Scroll to Anchor-Plugin
 */
export class ScrollToAnchor {
    protected element: HTMLElement;
    static offset: number = -80;

    constructor(element: HTMLElement) {
        this.element = element;

        this.waitForPageLoadedQueue();

        this.element.addEventListener('click', this.scrollOnEvent, {passive: false});
        this.element.addEventListener('touchend', this.scrollOnEvent, {passive: false});
    }

    /**
     * Scroll to an element if the page was loaded and pageLoadedQueue is finished
     */
    protected waitForPageLoadedQueue = () => {
        const targetEl = getElementTargetFromUri();

        if (targetEl instanceof HTMLElement) {
            document.addEventListener('Plandent.pageLoadedQueue.loaded',() => {
                scrollToElement(targetEl);
            }, {passive: true});
        }
    }

    /**
     * Initialize event listeners
     */
    protected scrollOnEvent = (e: Event) => {
        const target = <Element>e.target;
        const closest = target.closest('a[href^="#"]:not([data-bs-toggle="collapse"],[data-bs-toggle="tab"],[href="#"])');

        if (closest) {
            e.preventDefault();

            const href = closest.getAttribute('href');
            const tabs = document.querySelectorAll('.nav-tabs a[href="' + href + '"]');

            if (tabs.length) {
                tabs.forEach((tabEl) => {
                    if (tabEl.ariaExpanded == 'true') {
                        const tab = Tab.getOrCreateInstance(tabEl);
                        const tabButtons = document.querySelector('button[data-bs-toggle="tab"]');

                        tab.show();
                        tabButtons.addEventListener('shown.bs.tab', () => {
                            const targetEl = <HTMLElement>document.querySelector(href);

                            scrollToElement(targetEl);
                        });
                    }
                });
            } else {
                const targetEl = <HTMLElement>document.querySelector(href);

                scrollToElement(targetEl);
            }
        }
    }

    /**
     * Get the position of an element
     *
     * @param el
     * @private
     */
    static offsetOfElement = (el: HTMLElement) => {
        const rect = el.getBoundingClientRect();

        return {
            left: rect.left + window.scrollX,
            top: rect.top + window.scrollY
        }
    }
}

/**
 * Initialize scrollToAnchor
 */
export function initScrollToAnchor() {
    new ScrollToAnchor(document.body);
}

/**
 * Scroll smoothly to an element
 *
 * @param targetEl
 */
export function scrollToElement(targetEl: HTMLElement | null) {
    if (!targetEl) {
        return;
    }

    targetEl.scrollIntoView({
        behavior: 'smooth'
    });
}

/**
 * Get the target element from the URI
 */
export function getElementTargetFromUri(): HTMLElement | null {
    const url = new URL(window.location.toString());
    const anchorLink = url.hash;

    return anchorLink ? <HTMLElement>document.querySelector(anchorLink) : null;
}

// Scroll to the element
scrollToElement(getElementTargetFromUri());
